// Returns the current domain. Allows override with value in localStorage.
function getCurrentDomain() {
  const overrideDomain = process.env.DOMAIN_OVERRIDE
    ? localStorage.getItem('communityDomain')
    : null
  return overrideDomain || window.location.hostname
}

export default getCurrentDomain
